module.exports = __webpack_public_path__ + "static/media/science_hero_desktop.51f19ee3.png";